import {
	slideUpFn,
	slideDownFn,
	isMobDevice,
} from "./helpers";

import 'slick-carousel';

function setFormHeight() {
	$("iframe.hs-form-iframe").each(function () {

		const formEl = $(this).contents().find("form");
		const formElHeight = formEl.outerHeight();
		const iframeHeight = isMobDevice() ? formElHeight + 25 : formElHeight + (formElHeight * 20/100);
		$(this).css("min-height", iframeHeight);
		$(this).css("visibility", 'visible');
		$(this).closest('.hbspt-form').css({
			'padding-top': '20px',
			'padding-bottom': '20px',
			'border-color': '#ccc',
			'opacity': 1,
		});
	});
}

function setIfameHeight() {
	const adaptiveIframes = document.querySelectorAll('.adaptive-iframe');

	if(adaptiveIframes) {
		adaptiveIframes.forEach(function (item) {
			item.parentElement.style.maxWidth = '1200px';
			item.style.height = item.offsetWidth * 0.5625 + 'px';
		});
	}
}

function setOldFormStyle() {
	$("form.hs-form").each(function () {
		$(this).css("visibility", 'visible');
		$(this).closest('.ca-form-box').css({
			'padding': '20px',
			'border-color': '#ccc',
		});
	});
}

document.addEventListener("DOMContentLoaded", function () {

	/* Funtion toggle burger menu
	**************************************************************/
	let opacity = document.querySelector('.header__opacity');
	let body = document.querySelector('body');
	let scrollPosition = 0;
	let btn = document.querySelector('.toolbar__top_burger');
	let menu = document.querySelector('.nav-primary');

	function toggleBurgerMenu() {
		btn.addEventListener('click', function () {
			if (!menu.classList.contains('opened')) {
				openMenu();
			} else {
				closeMenu();
			}
		})
	}

	function closeMenu() {
		if (menu.classList.contains('opened')) {
			btn.classList.remove('opened');
			menu.classList.remove('opened');
			body.style.removeProperty('overflow');
			body.style.removeProperty('position');
			body.style.removeProperty('top');
			body.style.removeProperty('width');
			window.scrollTo(0, scrollPosition);
			opacity.classList.remove('active');
		}
	}

	function openMenu() {
		btn.classList.add('opened');
		menu.classList.add('opened');
		scrollPosition = window.pageYOffset;
		body.style.overflow = 'hidden';
		body.style.top = `-${scrollPosition}px`;
		body.style.position = 'fixed';
		body.style.width = '100%';
		opacity.classList.add('active');
	}

	/* Funtion open/close dropdown menu
	**************************************************************/
	function toggleDropdownMenu() {
		let carets = document.querySelectorAll('#primary-menu > li.menu-item-has-children a .caret');
		if (carets.length > 0) {
			for (let i = 0; i < carets.length; i++) {
				carets[i].addEventListener('click', function (e) {
					if (isMobDevice()) {
						e.preventDefault();
						let menuItems = carets[i].parentElement;
						let dropdownMenu = menuItems.nextElementSibling;

						if (menuItems.classList.contains('active')) {
							slideUpFn(dropdownMenu);
							menuItems.classList.remove('active');
						} else {
							menuItems.classList.add('active');
							slideDownFn(dropdownMenu);
						}
					}
				})
			}
		}
	}

	/* Funtion open/close footer dropdown menu
	**************************************************************/
	function toggleFooterMenu() {
		let menuItems = document.querySelectorAll('#footer-menu > li.menu-item-has-children a');
		if (menuItems.length > 0) {
			for (let i = 0; i < menuItems.length; i++) {
				menuItems[i].addEventListener('click', function (e) {
					if (isMobDevice()) {
						let caret = menuItems[i].querySelector('.caret');
						if (caret !== null) {
							let dropdownMenu = menuItems[i].nextElementSibling;
							e.preventDefault();

							if (menuItems[i].classList.contains('active')) {
								slideUpFn(dropdownMenu);
								menuItems[i].classList.remove('active');
							} else {
								menuItems[i].classList.add('active');
								slideDownFn(dropdownMenu);
							}
						}
					}
				})
			}
		}
	}

	/* Slider for pricing table
	**************************************************************/
	/* eslint-disable */
	if(jQuery('.pricing-table__grid').length > 0) {
		pricingTableSlider();
	}

	/* Slider Related posts
	**************************************************************/
	/* eslint-disable */
	if(typeof Swiper !== 'undefined') {
		const elem = jQuery(".related-posts__swiper");

		const slider = new Swiper(elem, {
		  init: true,
		  loop: true,
		  autoplay: {
			delay: 3000,
			disableOnInteraction: false
		  },
		  direction: "horizontal",
		  speed: 400,
		  slidesPerView: 4,
		  spaceBetween: 30,
		  centeredSlides: true,
		  pagination: {
			el: '.swiper-pagination',
			type: "bullets",
			clickable: true,
			renderBullet: function (index, className) {
			  if (index < 3) {
				return `<span class="swiper-pagination-bullet swiper-pagination-bullet-active visible" tabindex="0" role="button" aria-label="Go to slide"></span>`
			  }
			  return `<span class="swiper-pagination-bullet" style="display: none;" tabindex="0" role="button" aria-label="Go to slide"></span>`
			},
		  },
		  navigation: {
			nextEl: ".swiper-btn-next",
			prevEl: ".swiper-btn-prev",
		  },
		  breakpoints: {
			500: {
			  slidesPerView: 1,
			},
			991: {
			  slidesPerView: 2,
			},
		  },
		  on: {
			slideChange: function() {
			  let bullets = document.querySelectorAll(`.slider-news .swiper-pagination-bullet`);
			  let bulletActive = document.querySelector(`.slider-news .swiper-pagination-bullet-active`);

			  bullets.forEach(function(item) {
				let next = bulletActive.nextElementSibling;
				let prev = bulletActive.previousElementSibling;

				item.style.display = 'none'
				bulletActive.style.display = 'block';
				if(prev !== 'undefined' && prev !== null) {
				  prev.style.display = 'block'
				} else {
				  next.nextElementSibling.style.display = 'block';
				}
				if(next !== 'undefined' && next !== null) {
				  next.style.display = 'block'
				} else {
				  prev.previousElementSibling.style.display = 'block';
				}
			  })
			}
		  },
		});

		if(jQuery('.slider-news').width() > 1920) {
			const countClones = jQuery('.slider-news').width() / 392;
			const slides = document.querySelectorAll('.post-card.swiper-slide');

			for(let i = 0; i < countClones; i++) {
				slides.forEach(function (item) {
					document.querySelector('.slider-news .swiper-wrapper').append(item.cloneNode(true))
				});
			}
		}
	  }

	const hoverImages = document.querySelectorAll('.universal-card__img--with-hover');
	if(hoverImages) {
		hoverImages.forEach(function (item) {
			const imgSrc = item.src;
			item.addEventListener('mouseover', function () {
				item.src = item.dataset.hoverSrc;
			});
			item.addEventListener('mouseleave', function () {
				item.src = imgSrc;
			});
		});
	}

	/* Running functions
	**************************************************************/
	toggleBurgerMenu();
	toggleFooterMenu();
	toggleDropdownMenu();
	setIfameHeight();


	/* On Resize
	**************************************************************/
	window.addEventListener("resize", function () {
		isMobDevice();
		isMobDevice() ? '' : (closeMenu());
		setFormHeight();
		setIfameHeight();
	});

	if($('.group-wide-width').length > 0) {
		$('.group-wide-width').each(function () {
			$(this).parent().addClass('wide');
		});
	}

});

$(window).on('load', function () {
	setOldFormStyle();

	setTimeout(function () {
		setFormHeight();
	}, 1000);
});

window.addEventListener('message', event => {
	if(event.data.type === 'hsFormCallback' && event.data.eventName === 'onFormFailedValidation') {
		setFormHeight();
	}
});

function pricingTableSlider() {
	jQuery('.pricing-table__grid').slick({
		dots: false,
		infinite: true,
		speed: 300,
		slidesToShow: 1,
		mobileFirst: true,
		initialSlide: 2,
		prevArrow: '<a href="#" class="slick-prev"><svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
			'<path fill-rule="evenodd" clip-rule="evenodd" d="M14.7071 7.55071C15.0976 7.94123 15.0976 8.5744 14.7071 8.96492L10.9142 12.7578L14.7071 16.5507C15.0976 16.9412 15.0976 17.5744 14.7071 17.9649C14.3166 18.3554 13.6834 18.3554 13.2929 17.9649L8.79289 13.4649C8.40237 13.0744 8.40237 12.4412 8.79289 12.0507L13.2929 7.55071C13.6834 7.16018 14.3166 7.16018 14.7071 7.55071Z" fill="#2F3236"/>\n' +
			'</svg>\n</a>',
		nextArrow: '<a href="#" class="slick-next"><svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
			'<path fill-rule="evenodd" clip-rule="evenodd" d="M9.29289 7.55071C9.68342 7.16018 10.3166 7.16018 10.7071 7.55071L15.2071 12.0507C15.5976 12.4412 15.5976 13.0744 15.2071 13.4649L10.7071 17.9649C10.3166 18.3554 9.68342 18.3554 9.29289 17.9649C8.90237 17.5744 8.90237 16.9412 9.29289 16.5507L13.0858 12.7578L9.29289 8.96492C8.90237 8.5744 8.90237 7.94123 9.29289 7.55071Z" fill="#2F3236"/>\n' +
			'</svg>\n</a>',
	});
}

jQuery(window).on('load resize orientationchange', function() {
	const $carousel = jQuery('.pricing-table__grid');
	if($carousel.length > 0) {
		if ($(window).width() > 768) {
			if ($carousel.hasClass('slick-initialized')) {
				$carousel.slick('unslick');
			}
		}
		else{
			if (!$carousel.hasClass('slick-initialized')) {
				pricingTableSlider();
			}
		}
	}
});



// WEBPACK FOOTER //
// ./scripts/modules/global.js